module.exports = __webpack_public_path__ + "static/media/manage.6cdcae6b.png";